import { LogService } from "../../../../shared/services/log.service";
import { Validator } from "../../../../shared/services/validator";
import { RadioCheckBoxEnum } from "../../../common/radio.checkbox.enums";
import { CTRL_NAME_EXTRACTOR } from "../../ctrl.name.extractor";

export class CTRL_1087 implements Validator {

    public static id = 'CTRL_1087';
    private message = 'error.ctr_1087';


    public LOG: LogService = new LogService(CTRL_1087);

    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1087.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondChampNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];

                if (secondChampCtrl.value === RadioCheckBoxEnum.sadValue && this.isEmptyOrNullOrUndefined(firstChampCtrl.value)) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };  
                }
            }
        }
    }

    isEmptyOrNullOrUndefined(value): boolean {
		return (value === undefined || value === null || value === '');
	}
}